import { render } from "./UnidadeMedidaSelect.vue?vue&type=template&id=b6ac735e"
import script from "./UnidadeMedidaSelect.vue?vue&type=script&lang=js"
export * from "./UnidadeMedidaSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__